export const svgStringToBase64PNG = (
  width: number,
  height: number,
  svgString: string,
  callback: (pngData: string) => void,
): void => {
  const svgData = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgString)));
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  canvas.width = width;
  canvas.height = height;
  const image = new Image();

  image.onload = (): void => {
    context?.clearRect(0, 0, width, height);
    context?.drawImage(image, 0, 0, width, height);
    const pngData = canvas.toDataURL('image/png');
    callback(pngData);
  };
  image.src = svgData;
};
